export const blockIconsDeviceReviews = (
	<span className='material-symbols-outlined'>reviews</span>
);
